<template>
  <v-form ref="form" lazy-validation v-model="valid">
    <!-- <div v-if="removeButton" class="d-flex align-center">
      <v-card-title class="justify-center my-0 py-0 primary--text">
        {{ title }}
      </v-card-title>
      <v-btn small icon @click="$emit('remove')" class="ml-auto">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-card-title v-else class="justify-center my-0 py-0 primary--text">
      {{ title }}
    </v-card-title> -->

    <v-col cols="12">
      <!-- First Name -->
      <v-text-field
        type="text"
        ref="firstName"
        v-model="form.firstName"
        :rules="MIXINS_REQUIRED_RULES"
        class="mb-2"
        hide-details
      >
        <template v-slot:label>
          <span>First Name <span class="red--text">*</span></span>
        </template>
      </v-text-field>

      <!-- Middle Name -->
      <v-text-field
        type="text"
        ref="middleName"
        v-model="form.middleName"
        :rules="MIXINS_REQUIRED_RULES"
        class="mb-2"
        hide-details
      >
        <template v-slot:label>
          <span>Middle Name <span class="red--text">*</span></span>
        </template>
      </v-text-field>

      <!-- Last Name -->
      <v-text-field
        type="text"
        ref="lastName"
        v-model="form.lastName"
        :rules="MIXINS_REQUIRED_RULES"
        class="mb-2"
        hide-details
      >
        <template v-slot:label>
          <span>Last Name <span class="red--text">*</span></span>
        </template>
      </v-text-field>

      <!-- Birthdate -->
      <v-menu
        v-model="birthdateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <!-- [() => !!birthdate || 'This field is required'] -->
        <!-- hide-details -->
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            placeholder="M/D/YYYY"
            :rules="[
              ...MIXINS_REQUIRED_RULES,
              ...ageRules,
            ]"
            class="mb-2"
            v-model="formattedDate"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          >
            <template v-slot:label>
              <span>Birthdate <span class="red--text">*</span></span>
            </template>
          </v-text-field>
        </template>
        <v-date-picker
          v-model="form.birthdate"
          ref="birthdate"
          no-title
          @input="birthdateMenu = false"
        ></v-date-picker>
      </v-menu>

      <!-- Email Address -->
      <v-text-field
        type="text"
        ref="emailAddress"
        v-model="form.emailAddress"
        :rules="[...MIXINS_REQUIRED_RULES, ...MIXINS_EMAIL_RULES]"
        class="mb-2"
        hide-details
      >
        <template v-slot:label>
          <span>Email Address <span class="red--text">*</span></span>
        </template>
      </v-text-field>

      <!-- Contact Number -->
      <v-text-field
        type="text"
        ref="contactNumber"
        v-model="form.contactNumber"
        :rules="MIXINS_REQUIRED_RULES"
        class="mb-2"
        hide-details
      >
        <template v-slot:label>
          <span>Contact Number <span class="red--text">*</span></span>
        </template>
      </v-text-field>

      <!-- Access Key -->
      <v-text-field
        ref="accessKey"
        v-model="form.accessKey"
        :rules="MIXINS_REQUIRED_RULES"
        class="mb-2"
        :append-icon="showKey ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showKey ? 'text' : 'password'"
        @click:append="showKey = !showKey"
        hide-details
      >
        <template v-slot:label>
          <span>Access Key <span class="red--text">*</span></span>
        </template>
      </v-text-field>

      <!-- Activation Code -->
      <v-text-field
        ref="activationCode"
        v-model="form.activationCode"
        :rules="MIXINS_REQUIRED_RULES"
        class="mb-3"
        :append-icon="showCode ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showCode ? 'text' : 'password'"
        @click:append="showCode = !showCode"
        hide-details
      >
        <template v-slot:label>
          <span>Activation Code <span class="red--text">*</span></span>
        </template>
      </v-text-field>

      <!-- Child/Employee -->
      <v-radio-group v-if="childEmployee" v-model="form.employee" row hide-details>
        <v-radio label="Child" :value="true"></v-radio>
        <v-radio label="Employee" :value="false"></v-radio>
      </v-radio-group>
    </v-col>
  </v-form>
</template>

<script>
export default {
  data: () => ({
    valid: false,
    form: {},
    /* form fields */
    birthdateMenu: false,
    showCode: false,
    showKey: false,
  }),
  props: {
    childEmployee: { type: Boolean, default: false },
    ageRules: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    formattedDate() {
      let date = this.form.birthdate;
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    }
  }
}
</script>